import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stop-propagation"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
  }

  onClick(event) {
    event.stopPropagation()
  }
}